import { IHeaderComponentProps } from "./interface";

const HeaderComponent: React.FC<IHeaderComponentProps> = (props) => {
  return (
    <div className="m-4 w-full rounded-md ">
      <h3 className="text-base font-medium">{props?.title}</h3>
    </div>
  );
};
export default HeaderComponent;
